import $i18n from '@alife/panda-i18n';
import React from 'react';
import classnames from 'classnames';
import './index.scss';
const editPageMockData = [
    {
        label: $i18n.get({
            id: 'SummaryInformationComponentEditPageExample_1610268962',
            dm: '汇总信息组件编辑页示例',
        }),
        value: '99999',
        valueType: 'number',
    },
    {
        label: $i18n.get({ id: 'DocumentAddress', dm: '文档地址' }),
        value: 'https://alidocs.dingtalk.com/i/nodes/a9E05BDRVQRkezKGC1945qLyJ63zgkYA',
        valueFontSize: 12,
    },
];
const isEditPage = location.pathname === '/lowcode/edit';
const TableTopSummary = (props) => {
    const isL2Env = !!props._getCurrentTableInfo;
    const summaryData = props.summary || props._getCurrentTableInfo?.()?.__tableExtra__?.summary;
    const summary = isEditPage ? editPageMockData : summaryData || [];
    return (React.createElement("div", { className: classnames('table-top-summary', { l2: isL2Env }) }, summary.map((item) => {
        const { label = '', valueFontSize = 16, valueColor = '#397ae8', value, valueType, unit, } = item;
        const formattedValue = valueType === 'number' ? parseFloat(value).toLocaleString() : value;
        return (React.createElement("div", { className: 'table-top-summary-item' },
            React.createElement("span", { className: 'table-top-summary-item-label' }, label || ''),
            React.createElement("span", { className: 'table-top-summary-item-value', style: {
                    fontSize: valueFontSize,
                    color: valueColor,
                } }, typeof value === 'undefined' ? '' : formattedValue),
            React.createElement("span", { className: 'table-top-summary-item-unit' }, unit || '')));
    })));
};
TableTopSummary.displayName = 'TableTopSummary';
export { TableTopSummary };
